//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  input
} from '@angular/core';

import {
  FormGroup
} from '@angular/forms';

import { Transforms } from '@shared/helpers/transforms';

@Component({
    selector: 'number-input',
    templateUrl: './number-input.component.html',
    styleUrl: './number-input.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NumberInputComponent  {

  public id = input.required<string>();
  public formGroup = input.required<FormGroup>();  
  public label = input.required<string>();
  public focus = input(false, {
    transform: Transforms.toBoolean
  });
  
  public readonly = input(false, {
    transform: Transforms.toBoolean
  });

  public required = input(false, {
    transform: Transforms.toBoolean
  });

  constructor() {}
  
}
